<template>
  <generic-list v-bind="{ model, modelHeaders, filters }">
    <template v-slot:item.is_verified="{ item }">
      <v-simple-checkbox
        v-model="item.is_verified"
        disabled
      ></v-simple-checkbox>
    </template>
  </generic-list>
</template>

<script>
import models from "@/models"

export default {
  name: "List",
  data() {
    return {
      model: models.Person,
      modelHeaders: [
        { text: "Nome", value: "first_name" },
        { text: "Cognome", value: "last_name" },
        { text: "Nome d'arte", value: "stage_name" },
        { text: "Verificato", value: "is_verified" },
      ],
      filters: [
        { name: "category", model: models.PersonCategory, text: "name" },
        { name: "roles", model: models.PersonRole, text: "name" },
        { name: "instruments", model: models.Instrument, text: "name" },
      ],
    }
  },
}
</script>
